import { render, staticRenderFns } from "./m-chart-histogram.vue?vue&type=template&id=06113768&scoped=true&"
import script from "./m-chart-histogram.vue?vue&type=script&lang=js&"
export * from "./m-chart-histogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06113768",
  null
  
)

export default component.exports